export enum FeatureFlags {
  ORDER_YOUR_WEEKLY = 'ORDER_YOUR_WEEKLY',
  'ADD_CUSTOMER_FLOW' = 'ADD_CUSTOMER_FLOW'
}

export const hasUserFeatureFlag = (
  featureFlag: FeatureFlags,
  userFeatureFlags: string[] | undefined
) => {
  return userFeatureFlags && userFeatureFlags.includes(featureFlag);
};
